import { useCallback, useMemo } from "react";
import Particles from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export const ParticleBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const options = useMemo(
    () => ({
      background: {
        color: {
          value: "transparent",
        },
      },
      fpsLimit: 30, // Reduced for better performance
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: "grab",
          },
          resize: true,
        },
        modes: {
          grab: {
            distance: 120,
            links: {
              opacity: 0.4,
            },
          },
        },
      },
      particles: {
        color: {
          value: ["#2563EB", "#7C3AED"],
        },
        links: {
          color: "#2563EB",
          distance: 150,
          enable: true,
          opacity: 0.15,
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "out",
          },
          random: false,
          speed: 0.8, // Slower for smoother animation
          straight: false,
        },
        number: {
          density: {
            enable: true,
            area: 1000, // Reduced density
          },
          value: 40, // Fewer particles
        },
        opacity: {
          value: 0.3,
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 3 },
        },
      },
      detectRetina: false, // Disable retina for performance
      smooth: true,
    }),
    []
  );

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={options}
      className="absolute inset-0 z-0"
      style={{ willChange: "transform" }}
    />
  );
};

export default ParticleBackground;
